/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini.ts";

function getPostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/invoice-future-payment-vanzolini` as const,
  };
  return res;
}

/**
 * @description Variante do InvoiceFuturePayment com e-mail de destino. O envio do e-mail é feito pela camada de notificação (corpo/e-mail gravados). Migrado do legado IndividualPayment/InvoiceFuturePaymentVanzolini. **(Requer Authorization para autenticação)**
 * @summary Antecipa a emissão da NF no pagamento futuro com e-mail (Vanzolini) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-future-payment-vanzolini}
 */
export async function postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"],
  params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
